<template>
    <div class="ps-page--simple">
        <div class="ps-breadcrumb">
            <div class="container">
                <ul class="breadcrumb">
                    <li v-if="isEnglish()==true"><router-link  to="/products" >Products</router-link></li>
                    <li v-if="isEnglish()==false"><router-link  to="/products" >Produits</router-link></li>
                    <li v-if="isEnglish()==true">Cart</li>
                    <li v-if="isEnglish()==false">Panier</li>
                </ul>
            </div>
        </div>
        <div class="ps-section--shopping ps-shopping-cart">
            <div class="container">
                <div class="ps-section__header">
                    <h1 v-if="isEnglish()==true">Shopping Cart</h1>
                    <h1 v-if="isEnglish()==false">Panier d'achats</h1>
                </div>
                <div class="ps-section__content">
                    <div class="table-responsive">
                        <table class="table ps-table--shopping-cart ps-table--responsive">
                            <thead>
                                <tr v-if="isEnglish()==true">
                                    <th clss="product">Product name</th>
                              
                                    <th class="quantity">QUANTITY</th>
                                   
                                    <th>&nbsp;</th>
                                </tr>
                                 <tr v-if="isEnglish()==false">
                                    <th clss="product">Nom produit</th>
                              
                                    <th class="quantity">Quantité</th>
                                   
                                    <th>&nbsp;</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr  v-for="item in cart" :key="item.id">
                                    <td data-label="Product">
                                        <div class="ps-product--cart">
                                            <div class="ps-product__thumbnail"><a ><img :src="item.image_url" alt=""></a></div>
                                            <div class="ps-product__content"><a >{{item.description}}</a>
                                                <!-- <p>Sold By:<strong> YOUNG SHOP</strong></p> -->
                                            </div>
                                        </div>
                                    </td>
                                   
                                    <td data-label="Quantity">
                                        <div class="form-group--number">
                                            <button class="up"  @click="increase_quantity(item)">+</button>
                                            <button class="down" @click="decrease_quantity(item)">-</button>
                                            <input class="form-control"  @change="validate_quantity(item, $event)" type="number" :value="item.minimum_quantity">
                                        </div>
                                    </td>
                                  
                                    <td data-label="Actions"><a v-on:click="remove_from_cart(item)"><i class="icon-cross"></i></a></td>
                                </tr>
                               
                              
                            </tbody>
                        </table>
                    </div>
                    <div class="ps-section__cart-actions">
                        
                         <router-link v-if="isEnglish()==true" class="ps-btn" to="/products" ><i class="icon-arrow-left"></i> Back to Shop</router-link>
                         <router-link v-if="isEnglish()==false" class="ps-btn" to="/products" ><i class="icon-arrow-left"></i> Retourner aux produits</router-link>
                        


                         <a v-if="isEnglish()==true" class="ps-btn" href="/#/Checkout">Order</a>
                         <a v-if="isEnglish()==false" class="ps-btn" href="/#/Checkout">Commander</a>

                    </div>
                </div>
                <div class="ps-section__footer">
                    <div class="row">
                        
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
  name: 'Cart',
  props: ['search_on','search_obj','language'],
  data () {
    return {
      msg: 'Welcome to Your Vue.js App',
      cart : [] ,
      isEn: true,
      lang : this.language,
      clicked :false,
    }
  },

methods:{


    remove_from_cart(item){
      
       var removeIndex = this.cart.map(function(item) { return item.id; }).indexOf(item.id);
       this.cart.splice(removeIndex,1);
        //console.log(this.cart);

        localStorage.setItem('basket',JSON.stringify(this.cart));
         this.$parent.cart = this.cart;

       this.clicked = true;

        setTimeout(function(){
        this.clicked = false;
       }.bind(this),1000);
       
     },

    increase_quantity(item){
        var removeIndex = this.cart.map(function(item) { return item.id; }).indexOf(item.id);
        if( this.cart[removeIndex].minimum_quantity < this.cart[removeIndex].available_quantity){
         
        this.cart[removeIndex].minimum_quantity++;
        this.$parent.cart[removeIndex].minimum_quantity++
        localStorage.setItem('basket',JSON.stringify(this.cart));

        }
    
      },

    decrease_quantity(item){
         var removeIndex = this.cart.map(function(item) { return item.id; }).indexOf(item.id);
        
        //  this.noRecord = false;
        if( this.cart[removeIndex].minimum_quantity> 1){
         this.cart[removeIndex].minimum_quantity--;
         this.$parent.cart[removeIndex].minimum_quantity--;
         localStorage.setItem('basket',JSON.stringify(this.cart));
        }
       
    },

    validate_quantity(item, event){
        var removeIndex = this.cart.map(function(item) { return item.id; }).indexOf(item.id);
        if( event.target.value > this.cart[removeIndex].available_quantity){         
            this.cart[removeIndex].minimum_quantity = this.cart[removeIndex].available_quantity;
            this.$parent.cart[removeIndex].minimum_quantity = this.cart[removeIndex].minimum_quantity;
            event.target.value = this.cart[removeIndex].minimum_quantity
            localStorage.setItem('basket',JSON.stringify(this.cart));
        }       
    },

    isEnglish(){

            let lang = localStorage.getItem('lang');
            if(lang=='en'){

            return true;

            }else if(lang=='fr'){
            
            return false;

            }else{

            return true;

            }

    },

},


watch: {

      search_on:function(){
        //console.log("value of search_on is :"+this.search_on);
        

        if(this.search_on){

          //this.search_user_products(this.search_obj);
           //this.$parent.search_on = false;
           this.$router.push('/products');

        }
        
        //console.log(this.search_obj);
      },
      
      language:function(){
        this.lang = this.language;
        //console.log("language value has changed in private component");
        this.isEn = this.isEnglish();
      },

},

created(){

      //console.log("printing the cart in the cart view:");

      //console.log(this.cart);

},

mounted(){

  

     if( localStorage.getItem('basket')!="" &&  localStorage.getItem('basket')!=null){

        this.cart = JSON.parse(localStorage.getItem('basket')) ;

        }

},


}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>


             


// WEBPACK FOOTER //
// src/components/Cart.vue